import type { FaireProductEntity } from "../../entity_types/product";

export const p_3y3r0w7vnz: FaireProductEntity = {
  token: "p_3y3r0w7vnz",
  type: "product",
  name: "Card Holder",
  brandName: "BIDKhome",
  imageUrl:
    "https://cdn.faire.com/fastly/b0173dd865259a9409076b0a898559364f0f7a69bc9753363f3dd96f3f90c5da.jpeg",
  priceDollars: 2.8,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a53a09e3e3bbcf9239ad1b11dd3b95987c2b5c79c5ab89944336e8dbd579d9ff.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
